
import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ActionsDropdown from "../ActionsDropdown";
import { Link } from "react-router-dom";

import Select from "react-select";
import styled from "styled-components";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(odd) {
    background-color: #f2f2f2; /* Light gray for even rows */
  }

  tr:nth-child(even) {
    background-color: #ffffff; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};


function Studentdairy() {

  const [responseData, setResponseData] = useState([]);
  const [student_dairy_overall, setStudent_dairy_overall] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdateShowModal, setUpdateShowModal] = useState(false);
  const [responseDatas, setResponseDatas] = useState([]);
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [loading, setLoading] = useState(false)
  const [branch, setbranch] = useState([]);
  const [courseinfo, setcourseinfo] = useState([]);
  const [filtercourse, setcourses] = useState([]);
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});

  const formatDate = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };

  const [addData, setAddData] = useState({
    branch_id: "",
    student: "",
    roll_no: "",
    course: "",
    date: formatDate(new Date()),
    login: "",
    logout: "",
    topic_covered: "",
    subtopic: "",
    notes: "",
    studyingstudent: "",
    course_id: "",
  });
  // console.log("student:", addData);
  const [updateData, setUpdateData] = useState({
    branch_id: "",
    student: "",
    roll_no: "",
    course: "",
    date: "",
    login: "",
    logout: "",
    topic_covered: "",
    subtopic: "",
    notes: "",
  });

  const handleDateChange = (e) => {
    setAddData((prevData) => ({
      ...prevData,
      date: e.target.value, // Input type=date handles the format
    }));
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const fetchData = async () => {
  //   try {
  //     const response = await axios.get(apiUrl + "/student_dairy", {
  //       params: { data: localStorage.getItem("branch_id") },
  //     });


  //     if (response && response.status == 200) {
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 300);
  //     }


  //     const responseovelldata = await axios.get(
  //       apiUrl + "/student_dairy_overall"
  //     );


  //     if (responseovelldata && responseovelldata.status == 200) {
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 300);
  //     }



  //     console.log("Response from server:", response.data);
  //     console.log(
  //       "Response from server responseovelldata:",
  //       responseovelldata.data
  //     );
  //     setResponseData(response.data.reverse());
  //     setStudent_dairy_overall(responseovelldata.data.reverse());
  //   } catch (error) {
  //     console.error("Error fetching data:", error.message);
  //   }
  // };



  const fetchData = async () => {
    const branch_name = localStorage.getItem("branch_name");

    try {
      if (branch_name === "Branches") {
        // Fetch branch-based data
        const response = await axios.get(apiUrl + "/student_dairy", {
          params: { data: localStorage.getItem("branch_id") },
        });

        if (response && response.status === 200) {
          setTimeout(() => {
            setLoading(false);
          }, 300);
        }

        const responseOverallData = await axios.get(apiUrl + "/student_dairy_overall");

        if (responseOverallData && responseOverallData.status === 200) {
          setTimeout(() => {
            setLoading(false);
          }, 300);
        }

        console.log("Response from server:", response.data);
        console.log("Response from server responseOverallData:", responseOverallData.data);
        setResponseData(response.data.reverse());
        setStudent_dairy_overall(responseOverallData.data.reverse());
      } else {
        // Get 'username' and 'internal_emp' from localStorage
        const username = localStorage.getItem("username");
        const internal_emp = localStorage.getItem("internal_emp");

        setLoading(true); // Set loading state to true before fetching data

        try {
          // Fetch student dairy data
          const studentDairyResponse = await axios.get(apiUrl + "/student_dairy",

          );

          // Fetch student dairy overall data
          const studentDairyOverallResponse = await axios.get(apiUrl + "/student_dairy_overall");

          // Filter staff data based on assign_staff_lead._id matching either username or internal_emp
          const filteredStaffData = studentDairyOverallResponse.data.filter(
            (item) => item.staff_data[0]?.empid === username || item.staff_data[0]?.empid === internal_emp
          );





          console.log("Filtered data by ID:", filteredStaffData);

          // Check if both responses are successful
          if (studentDairyResponse.status === 200 && studentDairyOverallResponse.status === 200) {
            setLoading(false); // Set loading to false after fetching is done

            // Process the data as needed (reversing the data in this case)
            console.log("Response from server (Student Dairy):", studentDairyResponse.data);
            console.log("Filtered staff data:", filteredStaffData);

            setResponseData(studentDairyResponse.data.reverse());
            setStudent_dairy_overall(filteredStaffData);
          } else {
            console.error("Error: One or more API requests failed.");
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          setLoading(false);
        }
      }

    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false); // Ensure loading is turned off in case of an error
    }

  };

  useEffect(() => {
    fetchDatas();
    fetchDataed();
    gettoken();
    getprevillages();
  }, []);

  const fetchDatas = async () => {
    try {
      const response = await axios.get(apiUrl + "/staff");
      console.log("Response from:", response.data);
      setResponseDatas(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const gettoken = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);
      console.log("The role id is : ", response.data.detail.rolename);
      setroleid(response.data.detail.rolename);
      console.log("the role_id is : ", role_id);
      localStorage.setItem("role_id", response.data.detail.rolename);
      const id = response.data.detail.rolename;

      if (id) {
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);
    const total_previlages = username.modules;
    const new_enquiry = total_previlages.find(
      (item) => item.name == "Students Dairy"
    );
    console.log("the new_enquiry is : ", new_enquiry.actions);
    setprevillages(new_enquiry.actions);
  };

  const [getCoursesAll, setCourseAll] = useState([]);
  const [getRollAll, setRollAll] = useState([]);
  const fetchDataed = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      const responsecourse = await axios.get(apiUrl + "/course");
      const responseRole = await axios.get(apiUrl + "/student");
      const courseinfo = await axios.get(apiUrl + "/courseinfo");
      console.log("Response from server:", response.data);
      console.log("Response from server:courseinfo", courseinfo);
      setCourseAll(responsecourse.data);
      setRollAll(responseRole.data);
      setbranch(response.data);
      setcourseinfo(courseinfo.data);
      console.log("course dropdown", courseinfo.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const handleAddSubmit = async (e) => {
    console.log("SUbmit");
    e.preventDefault();
    if (!validateFields()) {
      console.log("validation fail");
      return;
    }
    // ============== code to calculate the workhour ========================
    const workhour = calculateWorkHours(addData.login, addData.logout);
    console.log("the workhour in the handleAddSubmit is : ", workhour);
    // ============== code to calculate the workhour ========================

    try {
      console.log(subTopics, "Subtopis Value form data");
      const formData = {
        branch_id: addData.branch_id,
        student: addData.student,
        roll_no: addData.roll_no,
        course: addData.course,
        date: addData.date,
        login: addData.login,
        logout: addData.logout,
        topic_covered: topics,
        subtopic: subtopics,
        notes: addData.notes,
        course_id: addData.course_id,
        studyingstudent: addData.studyingstudent,
        totalhour: workhour
      };
      console.log("addData in handleAddSubmit is :", formData);
      console.log(formData, "Submitting form data");
      const response = await axios.post(apiUrl + "/student_dairy", formData);
      console.log("Added:", response);
      setShowModal(false);
      fetchData(); // Assuming this refreshes the data to show the newly added student entry
      toast.success("Added successfully!");
      setAddData({
        branch_id: "",
        student: "",
        roll_no: "",
        course: "",
        date: formatDate(new Date()), // Ensuring date resets to current date
        login: "",
        logout: "",
        topic_covered: "",
        subtopic: "",
        notes: "",
        totalhour: "",
      });
    } catch (error) {
      console.error("Error adding data:", error.message);
      toast.error("Failed to add student diary entry."); // Show error notification
    }
  };

  // ======================= code to calculate the workhour ======================
  const calculateWorkHours = (login, logout) => {
    const loginTime = new Date(`1970-01-01T${login}:00`);
    const logoutTime = new Date(`1970-01-01T${logout}:00`);

    const totalWorkTime = logoutTime - loginTime;

    // Check for valid time difference
    if (totalWorkTime < 0) {
      console.error("Logout time must be after login time");
      return "00:00"; // Return default value if times are invalid
    }

    // const hours = Math.floor(totalWorkTime / (1000 * 60 * 60));

    let hours = (Math.floor(totalWorkTime / (1000 * 60 * 60)));  // the -1 is used to remve the brack time
    let minutes = Math.floor(
      (totalWorkTime % (1000 * 60 * 60)) / (1000 * 60)
    );

    // let overtime_hours = 0;
    // let overtime_minutes = 0;

    // if(hours > 8)
    // {
    //   overtime_hours = hours-8;
    //   hours = 8;
    //   overtime_minutes  = minutes;
    //   minutes = 0;
    // }
    // else if(hours == 8)
    // {
    //   overtime_minutes  = minutes;
    //   minutes = 0;
    // }

    console.log("the return value in calculateWorkHours is : ", loginTime, logoutTime);

    return `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;

    // return `${hours}:${minutes < 10 ? "0" : ""}${minutes}.${overtime_hours}:${overtime_minutes < 10 ? "0" : ""}${overtime_minutes}`;

  };
  // ======================= code to calculate the workhour ======================

  const railwayToNormalTime = (railwayTime) => {
    const [hour, minute] = railwayTime.split(":");
    const parsedHour = parseInt(hour);
    const parsedMinute = parseInt(minute);
    if (parsedHour < 12) {
      return `${parsedHour}:${minute} AM`;
    } else if (parsedHour === 12) {
      return `${parsedHour}:${minute} PM`;
    } else {
      return `${parsedHour - 12}:${minute} PM`;
    }
  };

  // const calculateWorkHours = (login, logout, lunch_out, lunch_in) => {
  //   const loginTime = new Date(`1970-01-01T${login}:00`);
  //   const logoutTime = new Date(`1970-01-01T${logout}:00`);
  //   const lunchoutTime = new Date(`1970-01-01T${lunch_out}:00`);
  //   const lunchinTime = new Date(`1970-01-01T${lunch_in}:00`);

  //   const totalWorkTime = logoutTime - loginTime - (lunchinTime - lunchoutTime);
  //   const hours = Math.floor(totalWorkTime / (1000 * 60 * 60));
  //   const minutes = Math.floor(
  //     (totalWorkTime % (1000 * 60 * 60)) / (1000 * 60)
  //   );
  //   console.log(
  //     "the return value",
  //     loginTime,
  //     logoutTime,
  //     lunchoutTime,
  //     lunchinTime
  //   );
  //   return `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;
  // };

  const [updateId, setUpdateId] = useState("");

  const handleUpdate = (_id, data) => {
    const selectedRollNo = data.course;
    console.log("this is ", selectedRollNo);
    const filteredCourses = courseinfo.filter(
      (item) => item.course_name == selectedRollNo
    );
    setDdtopics(filteredCourses);
    const filteredCoursess = courseinfo
      ?.filter((item) => item.course_name === selectedRollNo)
      ?.map((item, index, self) => {
        if (index === self.findIndex((t) => t.topics === item.topics)) {
          return item; // Keep the item
        }
        return null; // Ignore duplicate items
      })
      .filter((item) => item !== null); // Remove null values (duplicates)

    console.log("2222333", filteredCoursess);
    setDdtopicsupdate(filteredCoursess);

    const filteredItems = courseinfo.filter(
      (item) => item.topics == data.topic_covered
    );
    console.log("uiuiu", filteredItems);
    setSuptopicsfor(filteredItems);
    setsubtopic(filteredItems[0]?.subtopic);

    if (previllages.edit || previllages.all) {
      setUpdateId(_id);
      console.log("The data to update is", data);

      console.log("The data to update is121", data.branch_id.branch_name);
      console.log("The data to update is", data.branch_id[0]?._id);
      setUpdateShowModal(true);
      setUpdateData({
        branch_id: data.branch_id,
        student: data.student,
        course: data.course,
        roll_no: data.roll_no,
        date: data.date,
        login: data.login,
        logout: data.logout,
        topic_covered: data.topic_covered,
        subtopic: data.subtopic,
        notes: data.notes,
        totalhour: data.totalhour
      });
      console.log("The data to update is updateData", updateData);
    } else {
      toast.error("You don't have the permission to update");
    }
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); const workhour = calculateWorkHours(updateData.login, updateData.logout);
    console.log("the workhour in the handleAddSubmit is : ", workhour);


    try {
      const formData = {
        branch_id: updateData.branch_id[0]?._id,
        student: updateData.student,
        course: updateData.course,
        roll_no: updateData.roll_no,
        date: updateData.date,
        login: updateData.login,
        logout: updateData.logout,
        topic_covered: updateData.topic_covered,
        subtopic: updateData.subtopic,
        notes: updateData.notes,
        totalhour: workhour
      };
      console.log("The update submit data111", formData);
      const response = await axios.put(
        apiUrl + `/student_dairy/${updateId}`,
        formData
      );
      console.log("Response for update", response);
      setUpdateShowModal(false);
      toast.success("Update successfully!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      const response = await axios.delete(
        apiUrl + `/student_dairy/${getdeleteid}`
      );
      console.log("Deleted data", response);
      toast.error("Deleted successfully!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setDeleteShowModals(false);
      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error.message);
    }
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const handleOpenModal = (_id, student) => {
    if (previllages.all || previllages.delete) {
      console.log(" the id", _id);
      console.log(" the name", student);
      setdeleteid(_id);
      setdeletename(student);
      setDeleteShowModals(true);
    } else {
      toast.error("You don't have the permission to delete");
    }
  };

  // Pagination and search logic
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const filtered = currentItems.filter((item) =>
    Object.values(item).some(
      (value) =>
        (typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(responseData.length / itemsPerPage);

  const goToNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage === totalPages ? prevPage : prevPage + 1
    );
  };

  const goToPrevPage = () => {
    setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
  };



  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`} key="prev">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === 0 ? "active" : ""}`} key={0}>
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === 1 ? "active" : ""}`} key={1}>
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 3, currentPage + 1); i++) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 2 ? "active" : ""}`} key={totalPages - 2}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 2)}>
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 1 ? "active" : ""}`} key={totalPages - 1}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 1)}>
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };






  // console.log("getRollAll---===", getRollAll);
  const [ddTopics, setDdtopics] = useState([]);
  const [ddTopicsupdate, setDdtopicsupdate] = useState([]);
  const [supTopicsfor, setSuptopicsfor] = useState([]);

  const handleCourseChange = (e) => {
    const selectedRollNo = e.target.value;
    console.log("this is ", selectedRollNo);
    const filteredCourses = courseinfo.filter(
      (item) => item.course_name == selectedRollNo
    );
    setDdtopics(filteredCourses);

    // Update topics and subtopics based on the course selection
    const courseDetails = courseinfo.find(
      (item) => item.course_name === selectedRollNo
    );
    setTopics(courseDetails.topics); // Set topics based on the selected course
    setSubTopics(courseDetails.subTopics); // Set subtopics based on the selected course

    setAddData({ ...addData, course: e.target.value });
  };

  const handleCourseChangeupdate = (e) => {
    const selectedRollNo = e.target.value;
    console.log("this is ", selectedRollNo);
    const filteredCourses = courseinfo.filter(
      (item) => item.course_name == selectedRollNo
    );
    setDdtopics(filteredCourses);

    const filteredCoursess = courseinfo
      ?.filter((item) => item.course_name === selectedRollNo)

      ?.map((item, index, self) => {
        // Only keep the first occurrence of each unique combination of course_name and topics
        if (index === self.findIndex((t) => t.topics === item.topics)) {
          return item; // Keep the item
        }
        return null; // Ignore duplicate items
      })
      .filter((item) => item !== null); // Remove null values (duplicates)

    console.log("2222333", filteredCoursess);
    setDdtopicsupdate(filteredCoursess);
  };
  const [topics, setTopics] = useState([]);
  const [subtopics, setsubtopic] = useState([]);

  const [subTopics, setSubTopics] = useState([]);

  const handelRole = (e) => {
    const selectedRollNo = e.target.value;
    console.log("handelRole---", selectedRollNo);

    const selectedStudent = getRollAll.find(
      (item) => item.roll_no == selectedRollNo
    );

    console.log("handelRole selectedStudent---", selectedStudent);
    console.log(
      "handelRole selectedStudent1---",
      selectedStudent?.branch_lead.branch_id
    );

    const topicsfilter = selectedStudent?.Prefered_course_lead;
    const topic = courseinfo.find((item) => item.course_name == topicsfilter);
    setTopics(topic?.topics);

    setsubtopic(topic?.subtopic);

    const subtopicsfilter = selectedStudent?.Prefered_course_lead;
    const subtopic = courseinfo.find(
      (item) => item.course_name == subtopicsfilter
    );
    setSubTopics(subtopic?.subTopics);

    const studentName = selectedStudent?.student_name_lead || null;
    const studentcourse = selectedStudent?.Prefered_course_lead || null;
    const studentbranchid = selectedStudent?.branch_lead[0]?._id || null;
    const studyingstudent = selectedStudent?._id || null;
    const course_id = selectedStudent?.course_id || null;
    const branchid = selectedStudent?.branch_lead._id || null;

    const courseinfoss = courseinfo.find(
      (item) => item.course_name == studentcourse
    );
    console.log("handelRole courseinfoss---", courseinfoss);

    const filteredCourses = courseinfo
      ?.filter((item) => item.course_name === courseinfoss?.course_name)

      ?.map((item, index, self) => {
        // Only keep the first occurrence of each unique combination of course_name and topics
        if (index === self.findIndex((t) => t.topics === item.topics)) {
          return item; // Keep the item
        }
        return null; // Ignore duplicate items
      })
      .filter((item) => item !== null); // Remove null values (duplicates)

    console.log(filteredCourses);

    // console.log(filteredCourses2, "filteredCourses2");
    console.log(
      "handelRole filteredCourses---",
      filteredCourses,
      courseinfoss?.course_name
    );
    const uniqueTopics = [
      ...new Set(filteredCourses?.map((session) => session.topics)),
    ];
    setDdtopics(filteredCourses);
    console.log("unique is work", uniqueTopics);

    const filteredItems = courseinfo.filter(
      (item) => item.topics == topic?.topics
    );
    console.log("uiuiu", filteredItems);
    setSuptopicsfor(filteredItems);
    setsubtopic(filteredItems[0]?.subtopic);
    setcourses(courseinfoss);
    setAddData({
      ...addData,
      roll_no: selectedRollNo, // Set the selected roll number
      student: studentName, // Safely set the student name
      course: studentcourse,
      studyingstudent: studyingstudent,
      course_id: course_id,
      branch_id: branchid,
    });
  };

  const handleDateChangee = (e) => {
    setUpdateData({ ...updateData, date: e.target.value });
  };

  const handlesubtopic = (e) => {
    setsubtopic(e.target.value);
  };
  // Helper function to format ISO date to YYYY-MM-DD
  const formatDatefitching = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  function AllDataHandale() {



    setLoading(true);
    setTimeout(() => {
      setResponseData(student_dairy_overall);
      setStudent_dairy_overall(responseData);
      setLoading(false);
    }, 500);

  }
  const navigate = useNavigate();

  const updateinfo = (id) => {
    navigate(`/StudentInfo/${id}`);
  };

  const [errors, setErrors] = useState({});

  const validateFields = () => {
    let tempErrors = {};
    let isValid = true;

    if (!addData.branch_id) {
      tempErrors.branch_id = "Branch is required.";
      console.log("branch_id is error");
      isValid = false;
    }

    if (!addData.roll_no) {
      tempErrors.roll_no = "StudentName is required.";
      console.log("roll_no is error");
      isValid = false;
    }

    if (!addData.login) {
      tempErrors.login = "Login is required.";
      console.log("login is error");
      isValid = false;
    }

    if (!addData.notes) {
      tempErrors.notes = "Notes is required.";
      console.log("notes is error");
      isValid = false;
    }
    setErrors(tempErrors);
    return isValid;
  };

  const [rolename, setrolename] = useState([]);
  useEffect(() => {
    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);



  const convertTo12HourFormat = (time) => {
    let [hours, minutes] = time.split(':');
    let period = 'AM';

    hours = parseInt(hours, 10);

    if (hours >= 12) {
      period = 'PM';
      if (hours > 12) {
        hours -= 12;
      }
    } else if (hours === 0) {
      hours = 12;
    }

    return `${hours}:${minutes} ${period}`;
  };


  function filterSubtaopic(value) {
    setTopics(value);
    console.log("ggy", courseinfo);

    const filteredItems = courseinfo.filter((item) => item.topics == value);
    console.log("uiuiu", filteredItems);
    setSuptopicsfor(filteredItems);
    setsubtopic(filteredItems[0]?.subtopic);
  }

  function handelUpdateSubtopic(e) {
    console.log("handelUpdateSubtopic", e.target.value);

    const filteredCourses = courseinfo.filter(
      (item, index) => item.topics == e.target.value
    );
    console.log(filteredCourses, "courseinfo-filteredCourses");
    console.log(filteredCourses[0]?.subtopic, "courseinfo-filteredCourses");

    setSuptopicsfor(filteredCourses);
    setUpdateData({
      ...updateData,
      topic_covered: e.target.value,
      subtopic: filteredCourses[0]?.subtopic,
    });
  }





  const data = useMemo(() => {
    return responseData.map((item) => ({
      _id: item._id,
      branch_id: {
        _id: item.branch_id?._id || null,
        branch_name: item.branch_id?.branch_name || "",
      },
      date: item.date || "",
      student: item.student || "",
      roll_no: item.roll_no || "",
      course: item.course || "",
      login: item.login || "",
      logout: item.logout || "",
      topic_covered: item.topic_covered || "",
      subtopic: item.subtopic || "",
      course_id: item.course_id || "null",
      totalhour: item.totalhour || "",
      notes: item.notes || "",
      studyingstudent: item.studyingstudent || "",
      __v: item.__v || 0,
    }));
  }, [responseData]);



  useEffect(() => {

    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        id: "serialNo",
        Cell: ({ row }) => row.index + 1,
      },
      ...(rolename === "branches"
        ? [
          {
            Header: "Branch",
            accessor: "branch_id",
            Cell: ({ row }) => {
              const branch = row.original.branch_id;
              return branch?.branch_name || "No Branch";
            },
            Filter: DefaultColumnFilter,
            filter: "multiSelectFilter",
          },
        ]
        : []), // Empty array means no column added

      {
        Header: "Student",
        accessor: "student",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Course",
        accessor: "course",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Date",
        accessor: (row) => {
          const date = new Date(row.date);
          return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1)
            .toString()
            .padStart(2, "0")}-${date.getFullYear()}`;
        },
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Topic Covered",
        accessor: "topic_covered",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Sub Topic",
        accessor: "subtopic",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Log In",
        accessor: "login",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => convertTo12HourFormat(value), // convert time here
      },
      {
        Header: "Log Out",
        accessor: "logout",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => convertTo12HourFormat(value), // convert time here
      },
      {
        Header: "Total Hour",
        accessor: "totalhour",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },


    ],
    []
  );



  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );



  const handleClick = (_id) => {
    navigate(`/studentdairy_upload`);
  };




  return (
    <>

      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}

      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-3">
            <div className="col-lg-8">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>Student Dairy</b>
              </Link>
            </div>
            <div className="col-lg-4 d-flex justify-content-end">
              <div className="me-3">
                <button className="btn  btn-danger ms-5" onClick={AllDataHandale}>
                  Overall
                </button>
              </div>
              {rolename === "Branches" && (
                <div>

                  <button className="btn btn-secondary" onClick={handleClick}>
                    File Upload
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="mb-1 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1">
              <div className="d-flex">
                <h5 className="mt-1"> Student Dairy </h5>
                {previllages.add && (
                  <button
                    className="btn btn-success add mx-3"
                    onClick={() => setShowModal(true)}
                  >
                    Add
                  </button>
                )}
              </div>
            </div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end ">

              {/* </div>

            <div className="col-lg-3 col-md-4 col-sm-7"> */}
              <div className="w-full flex-1 me-5">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""} // Use the globalFilter value
                      onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                    />
                  </div>
                </form>
              </div>
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show : </label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'All') {
                        setPageSize(data.length);  // 'data' should be your dataset containing all the entries
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option> {/* Add 'All' option */}
                    {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>



        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">{column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}
                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={{
                        edit: previllages.edit,
                        delete: previllages.delete,
                      }}
                      onEdit={(id, row) => {
                        setLoading(true);
                        setTimeout(() => {
                          handleUpdate(id, row);
                          setLoading(false);
                        }, 500);
                      }}
                      onDelete={(id, row) => {
                        handleOpenModal(id, row.student);
                      }}
                      onInfo={(id, row) => {
                        setLoading(true);
                        setTimeout(() => {
                          updateinfo(row.studyingstudent);
                          setLoading(false);
                        }, 500);
                      }}
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>



        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Add Student Dairy </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleAddSubmit}>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <div className="floating-label">
                      <select
                        className="form-select"
                        value={addData.roll_no}
                        onChange={(e) => handelRole(e)}
                      >
                        <option value="">Select Student</option>
                        {getRollAll.map((item, index) => (
                          <option key={index} value={item.roll_no}>
                            {item.roll_no} - {item.student_name_lead}
                          </option>
                        ))}
                      </select>
                      <label className={addData.roll_no ? "filled" : ""}>
                        {/* Select Student */}
                      </label>
                      {errors.roll_no && (
                        <div className="error-text">{errors.roll_no}</div>
                      )}
                    </div>
                    {console.log("THIS IS FOR A", addData)}
                    <div className="floating-label">
                      <select
                        className="form-select"
                        value={addData.branch_id}
                        onChange={(e) =>
                          setAddData({ ...addData, branch_id: e.target.value })
                        }
                        disabled
                      >
                        <option>Select Branch</option>
                        {branch.map((item, index) => (
                          <option key={index} value={item._id}>
                            {item.branch_id} - {item.branch_name}
                          </option>
                        ))}
                      </select>
                      <label className={addData.branch_id ? "filled" : ""}>
                        Select Branch
                      </label>
                      {errors.branch_id && (
                        <div className="error-text">{errors.branch_id}</div>
                      )}
                    </div>


                    <div className="floating-label">
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""

                        value={addData.roll_no}
                        onChange={(e) =>
                          setAddData({
                            ...addData,
                            roll_no: e.target.value,
                          })
                        }
                        required
                        disabled
                      />
                      <label className={addData.roll_no ? "filled" : ""}>
                        Roll No
                      </label>
                    </div>


                    <div className="floating-label">
                      <select
                        className="form-select"
                        value={addData.course}
                        onChange={handleCourseChange}
                        disabled
                      >
                        <option> Select Course</option>
                        {getCoursesAll.map((item, index) => (
                          <option key={index} value={item.course_name}>
                            {item.course_name}
                          </option>
                        ))}
                      </select>
                    </div>


                    <div className="floating-label">
                      <select
                        className="form-select"
                        value={topics}
                        onChange={(e) => {
                          console.log("kkkk", e.target.value);
                          filterSubtaopic(e.target.value);
                        }}
                      >
                        <option> Select Topic</option>
                        {ddTopics.map((item, index) => (
                          <option key={index} value={item.topics}>
                            {item.topics}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={subtopics}
                      onChange={handlesubtopic}
                    >
                      <option> Select SubTopic</option>
                      {supTopicsfor.map((item, index) => (
                        <option key={index} value={item.subTopics}>
                          {" "}
                          {item.subtopic}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""

                      value={addData.date}
                      onChange={handleDateChange}
                      required
                    />
                    <label className={addData.date ? "filled" : ""}>
                      Date
                    </label>
                    {errors.date && (
                      <div className="error-text">{errors.date}</div>
                    )}
                  </div>
                  <div className="floating-label">
                    <input
                      type="time"
                      className="form-control"
                      placeholder=""
                      value={addData.login}

                      onChange={(e) =>
                        setAddData({ ...addData, login: e.target.value })
                      }
                    />
                    <label className={addData.login ? "filled" : ""}>
                      Log In
                    </label>
                    {errors.login && (
                      <div className="error-text">{errors.login}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    <input
                      type="time"
                      className="form-control"
                      placeholder=""

                      value={addData.logout}
                      onChange={(e) =>
                        setAddData({ ...addData, logout: e.target.value })
                      }
                    />
                    <label className={addData.logout ? "filled" : ""}>
                      Logout
                    </label>
                  </div>
                </div>
                <div className="floating-label col-lg-12">
                  <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    value={addData.notes}
                    onChange={(e) =>
                      setAddData({ ...addData, notes: e.target.value })
                    }
                  />
                  <label className={addData.notes ? "filled" : ""}>
                    Notes
                  </label>
                  {errors.notes && (
                    <div className="error-text">{errors.notes}</div>
                  )}
                </div>
              </div>

              <div className="modalbutton">
                <Button
                  variant="secondary"
                  className="mt-3 cancelbut"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </Button>
                <button
                  type="submit"
                  className="btn btn-primary mt-3 mx-2 submitbut"
                >
                  Submit
                </button>
              </div>



            </form>
          </Modal.Body>
        </Modal>

        <Modal
          className="custom-modal"
          show={isUpdateShowModal}
          onHide={() => setUpdateShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Update Student Diary</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleUpdateSubmit}>
              <div className="row">
                <div className="col-lg-6">
                  <div className="floating-label">
                    <input
                      type="text"
                      disabled
                      className="form-control"
                      placeholder=""
                      value={updateData.student}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          student: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.student ? "filled" : ""}>
                      Student
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      disabled
                      type="text"
                      placeholder=""
                      value={updateData.branch_id.branch_name}
                      required
                    />
                    <label className={updateData.branch_id ? "filled" : ""}>
                      Branch
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      disabled
                      value={updateData.roll_no}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          roll_no: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.roll_no ? "filled" : ""}>
                      Roll No
                    </label>
                  </div>

                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.course || ""}
                      onChange={(e) => {
                        handleCourseChangeupdate(e);
                        setUpdateData({
                          ...updateData,
                          course: e.target.value,
                        });
                      }}
                      disabled
                    >
                      {console.log("--updateData.course--", updateData.course)}
                      <option>Select Course</option>

                      {courseinfo.length > 0 ? (
                        [
                          ...new Map(
                            courseinfo.map((item) => [item.course_name, item]) // Filter unique course names
                          ).values(),
                        ].map((uniqueItem, index) => (
                          <option key={index} value={uniqueItem.course_name}>
                            {uniqueItem.course_name}
                          </option>
                        ))
                      ) : (
                        <option disabled>No topics available</option>
                      )}
                    </select>
                  </div>

                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.topic_covered}
                      onChange={(e) => {
                        handelUpdateSubtopic(e);
                      }}
                    >
                      {console.log(
                        "--updateData.topic_covered--",
                        updateData.topic_covered
                      )}
                      {/* <option>Select Topic</option>
                      {courseinfo.length > 0 ? (
                        courseinfo
                          .filter(
                            (item) =>
                              // Replace the condition below with your filtering logic
                              item.course_name == updateData.course // Example: Filtering by a selected category
                          )
                          .map((item, index) => (
                            <option key={index} value={item.topics}>
                              {item.topics}
                            </option>
                          ))
                      ) : (
                        <option disabled>No topics available</option>
                      )} */}
                      <option> Select Topic</option>
                      {ddTopicsupdate.map((item, index) => (
                        <option key={index} value={item.topics}>
                          {item.topics}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.subtopic}
                      onChange={(e) => {
                        setUpdateData({
                          ...updateData,
                          subtopic: e.target.value,
                        });
                      }}

                    >
                      {console.log(
                        "--updateData.subtopic--",
                        updateData.subtopic
                      )}
                      <option>Select Sub Topic</option>

                      {supTopicsfor.map((item, index) => (
                        <option key={index} value={item.subTopics}>
                          {" "}
                          {item.subtopic}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="floating-label">
                    <input
                      type="date"
                      className="form-control"
                      placeholder=""
                      disabled
                      value={formatDatefitching(updateData.date)}
                      onChange={handleDateChangee}
                      required
                    />
                    <label
                      className={
                        formatDatefitching(updateData.date) ? "filled" : ""
                      }
                    >
                      Date
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      type="time"
                      className="form-control"
                      placeholder=""
                      value={updateData.login}
                      disabled
                      onChange={(e) =>
                        setUpdateData({ ...updateData, login: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.login ? "filled" : ""}>
                      Log In
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      type="time"
                      className="form-control"
                      placeholder=""
                      value={updateData.logout}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, logout: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.logout ? "filled" : ""}>
                      Log Out
                    </label>
                  </div>
                </div>
                <div className="floating-label col-lg-12">
                  <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    value={updateData.notes}
                    onChange={(e) =>
                      setUpdateData({ ...updateData, notes: e.target.value })
                    }
                    required
                  />
                  <label className={updateData.notes ? "filled" : ""}>
                    Notes
                  </label>
                </div>
              </div>

              <div className="modalbutton">
                <Button
                  variant="secondary"
                  className="mt-3 cancelbut mx-2"
                  onClick={() => setUpdateShowModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className="btn btn-primary mt-3 submitbut"
                >
                  Update
                </Button>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        <Modal
          className="modal"
          show={deleteShowModals}
          onHide={handleCloseModal}
        >
          <Modal.Header>
            <p id="modeti">Are you sure you want to Delete?</p>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label d-flex">
              <h5 className="mx-1">Student :</h5> <h5>{getdeletename} </h5>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {state.pageIndex + 1} of {pageCount}
              </span>
            </div>
            <div className="col-lg-5">
              <div className="mt-3 pb-5">
                <nav>
                  <ul className="pagination justify-content-center">
                    {createPagination()} {/* Pagination buttons */}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}

export default Studentdairy;
